import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {}
  connect() {
    this.timer = setInterval(() => {
      this.element.reload();
    }, 10000);
  }

  disconnect() {
    clearInterval(this.timer);
  }
}
